// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { pencilToRectangle } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-pencil-to-rectangle': IconPencilToRectangle;
    }
}

/**
 * The icon component for the 'pencilToRectangle' icon
 */
export class IconPencilToRectangle extends IconSvg {
    public constructor() {
        super(pencilToRectangle);
    }
}

registerIconSvg('icon-pencil-to-rectangle', IconPencilToRectangle);
export const iconPencilToRectangleTag = 'nimble-icon-pencil-to-rectangle';
